import { FC } from 'react'
import Box from '@mui/material/Box'
import Slider from '@mui/material/Slider'
import { defaultMarks } from './options'
import { SliderSelectType } from './types'
import { RenderIf } from 'shared/helpers/renderIf'
import { FormLabel } from '@mui/material'

export const SliderSelect: FC<SliderSelectType> = ({
  marks = defaultMarks,
  width = 300,
  onChange,
  title = '',
  step = 5,
  defaultValue = 0
}) => {
  return (
    <Box sx={{ width }}>
      <RenderIf condition={Boolean(title)}>
        <FormLabel id='slider-label'>{title}</FormLabel>
      </RenderIf>
      <Slider
        defaultValue={defaultValue}
        step={step}
        marks={marks}
        color='warning'
        onChangeCommitted={(_e: any, value: number | number[]) => {
          if (typeof value === 'number') {
            onChange(value)
          }
        }}
      />
    </Box>
  )
}
